import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthDataDispatcher } from '../../../auth-data/auth-data.dispatcher';
import { LoggerService } from '../../../shared/services/logger/logger.service';
import { LoginBuilder } from './login.builder';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [LoginBuilder],
})
export class LoginComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  loggingIn: boolean;
  errorMessage: string;

  constructor(
    private _loggerService: LoggerService,
    private _loginBuilder: LoginBuilder,
    private _authDataDispatcher: AuthDataDispatcher,
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  ngOnInit() {
    this.form = this._loginBuilder.buildForm();

    this.errorMessage = null;
  }

  ngAfterViewInit() {
    this._document.body.classList.add('loaded');
  }

  login() {
    const username = this.form.get('username').value;
    const password = this.form.get('password').value;

    this.errorMessage = null;

    if (!this.loggingIn && username && password) {
      this.loggingIn = true;
      this._changeDetectorRef.markForCheck();

      this._authDataDispatcher.login(username, password).subscribe(
        (accounts: any[]) => {
          if (accounts.length > 1) {
            this._authDataDispatcher.login(
              username,
              password,
              accounts[0].account_id
            );
          }
        },
        (error) => {
          if (
            error[0] === 400 &&
            error[1] &&
            error[1].error_description === 'Invalid credentials'
          ) {
            this.errorMessage = 'The email or password entered is incorrect.';
          }

          this.loggingIn = false;

          this._changeDetectorRef.markForCheck();
        }
      );
    }
  }
}
